import { useMutation } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

interface IStartOtaPayload {
  lpUI: string;
  firmwareVersion: string;
}

interface IStartOtaResponse {
  job_id: string;
}

const startOtaMutation =
  (makeRequest: ReturnType<typeof useImperativeRequestWrapper>[1]) =>
  async ({
    lpUI,
    firmwareVersion,
  }: IStartOtaPayload): Promise<IStartOtaResponse> => {
    const { data, error } = await makeRequest({
      path: `/products/${lpUI}/ota/actions/start`,
      method: 'post',
      body: { firmware_version: firmwareVersion },
    });

    if (!data || error) {
      throw new Error(error?.response?.data?.message ?? error);
    }

    return data;
  };

type UseStartOtaOptions = {
  config?: MutationConfig<ReturnType<typeof startOtaMutation>>;
};

export const useStartOta = ({ config }: UseStartOtaOptions = {}) => {
  const [, makeRequest] = useImperativeRequestWrapper('deviceV3');

  return useMutation({
    ...config,
    mutationFn: startOtaMutation(makeRequest),
  });
};
